<template>
  <div>
    <b-button
      :disabled="!hasUpdatePermissions"
      :variant="'success'"
      class="mb-1 float-right"
      @click="importProgram()"
      >{{ $t("message.Импорт_програмы") }}</b-button
    >

    <date-picker
      v-model="curDate"
      class="float-left mb-3"
      :lang="lang"
      :format="'DD.MM.YYYY'"
      :clearable="false"
    ></date-picker>

    <b-table id="program-table" :items="programs" :fields="fields">
      <template slot="time" slot-scope="data"
        >{{ data.item.starts_at | moment("HH:mm") }}&nbsp;-&nbsp;{{
          data.item.ends_at | moment("HH:mm")
        }}</template
      >
      <template slot="min_age" slot-scope="data"
        >{{ data.item.min_age }}+</template
      >
    </b-table>
  </div>
</template>
<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";

Vue.use(require("vue-moment"));

export default {
  name: "ProgramForm",
  props: ["model"],
  components: { DatePicker },

  data() {
    return {
      programs: [],
      fields: [
        { key: "time", sortable: false },
        { key: "name", sortable: false },
        { key: "description", sortable: false },
        { key: "min_age", sortable: false }
      ],
      curDate: "",
      lang: "ru"
    };
  },
  computed: {
    hasUpdatePermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "channels:fully_manage").length;
    }
  },
  created: function() {
    let d = new Date();
    this.curDate = d.getTime();

    if (this.model.id) {
      let promise = this.$noname.getChild(
        "channels",
        this.model.id,
        "programs",
        {}
      );

      return promise
        .then(data => {
          this.programs = data.data.items;
        })
        .catch(this.$noname.HandleError);
    }
  },
  watch: {
    model: function() {
      this.updateProgram();
    },
    curDate: function() {
      this.updateProgram();
    }
  },

  updated: function() {
    // console.log(this.model);
    // if(this.model.id) {
    //     let promise = this.$noname.getChild('channels', this.model.id, 'programs/2019-01-01', {});
    //
    //     return promise.then((data) => {
    //         this.programs = data.data.items
    //     }).catch(this.$noname.HandleError)
    // }
  },
  methods: {
    updateProgram: function() {
      if (this.model.id) {
        let promise = this.$noname.getChild(
          "channels",
          this.model.id,
          "programs/" + this.$moment(this.curDate).format("DDMMYY"),
          {}
        );

        return promise
          .then(data => {
            this.programs = data.data.items;
          })
          .catch(this.$noname.HandleError);
      }
    },
    importProgram: function() {
      if (this.model.id) {
        let promise = this.$noname.getChild(
          "channels",
          this.model.id,
          "programs_import",
          {}
        );

        return promise.then(response => {
          // this.$root.$emit("bv::refresh::table", "program-table"); // не сработало почему то...
          this.updateProgram();
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Импорт_програмы_процесс"),
            type: "success"
          });
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/ProgramForm.vue